"use strict";

import {Component, OnInit, ViewChild} from "@angular/core";

import {IErrorObject} from "../../../../types/platform/universe";

import {BreakpointObserver} from "@angular/cdk/layout";
import {Overlay} from "@angular/cdk/overlay";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

import {environment} from '../../../environments/environment';

import {SessionService} from "../../platform/base/services/session.service";
import {ShotdataService} from "../shotdata/shotdata.service";

import {ResponsiveComponent} from "../../platform/base/components/responsive.component";
import {MessageDialogComponent} from "../base/components/message-dialog/message-dialog.component";
import {GuestsComponent} from "../guests/guests.component";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

import {GuestsService} from "../guests/guests.service";
import {Guests2Service} from "../guests2/guests2.service";

/**
 * todo
 */
@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})
export class HomeComponent extends ResponsiveComponent implements OnInit {

	public endPoint: string = "";

	public params: any = {};

	public pay_accounts: any[] = [];

	@ViewChild(GuestsComponent) protected guestsComponent: GuestsComponent;

	constructor(
		private listService: ShotdataService,
		private accountService: GuestsService,
		//private accountService: Guests2Service,			// todo:guests2
		public matDialog: MatDialog,
		protected session: SessionService,
		protected overlay: Overlay,
		protected breakpointObserver: BreakpointObserver,
		private router: Router,
		protected route: ActivatedRoute,
		public translate: TranslateService
	) {
		super(session, breakpointObserver);
		this.endPoint = environment.endPoint;
	}

	/**
	 *
	 * @param data
	 */
	public onPassword(data: any): void { //
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error: IErrorObject) => {}): void {
		if (error) {
			if (error.code === 1) {
				this.router.navigate(['/']);
			} else {
				const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: {title: "Error.", message: error.message, tag: error.tag}},
					disableClose: true,
				});

				dialog.afterClosed().subscribe((result: any): void => {
					callback(result);
				});
			}
		}
	}

	/**
	 *
	 * @returns none
	 */
	public ngOnInit(): void {
		super.ngOnInit();
		this.getSession((error: IErrorObject, session: object): void => {
			if (!error) {
				this.route.queryParams.subscribe(params => {
					this.params = params;
					this.draw();
				});
			}
		});
	}

	/**
	 *
	 * @returns none
	 */
	private draw(): void {
		this.accountService.belongs("", (error: IErrorObject, accounts: any[]) => {
			this.pay_accounts = accounts.filter((account) => {
				return (account.content.accounting);
			});
		});
	}

	/**
	 *
	 * @param data
	 * @returns none
	 */
	public onRegist(data: any): void { //
	}

	/**
	 *
	 * @param data
	 * @returns none
	 */
	public onLogout(data: any): void {
		location.reload();
	}

	/**
	 * @returns none
	 */
	public onUpdateAvatar(): void {
		this.onComplete({type: "", value: null});
	}

	/**
	 *
	 * @param event
	 */
	public onComplete(event: any): void {
		switch (event.type) {
			case "error" :
				this.errorDialog(event.value);
				break;
			default:
		}
	}

}
